
(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .controller('CadastroPropriedadesCtrl', CadastroPropriedadesCtrl);

  CadastroPropriedadesCtrl.$inject = [
    '$location',
    '$rootScope',
    '$routeParams',
    'LoadingService',
    'PropriedadesService',
    'Flash',
    'MessagesService'
  ];
  /*eslint-disable-next-line max-lines-per-function*/
  function CadastroPropriedadesCtrl($location, $rootScope, $routeParams, // eslint-disable-line max-params
    LoadingService, PropriedadesService, Flash, MessagesService) {
    const vm = this;
    //////////////////////////////////////////
    // Controller data
    vm.propriedades = [];
    vm.propriedade = null;
    vm.search = 'active';

    //////////////////////////////////////////
    // Bindable methods

    //////////////////////////////////////////
    // Function declarations
    vm.show = function(index) {
      vm.propriedade = vm.propriedades[index];

      if (vm.propriedade) {
        $location.path(`/cadastro_propriedades/${ vm.propriedade.id}`);
      }
    };

    vm.goToIndex = function() {
      $location.path('/cadastro_propriedades');
    };

    vm.edit = function() {
      $location.path(`/cadastro_propriedades/${ vm.propriedade.id }/edit`);
    };

    const permissions = function() {
      if ($rootScope.parametros.enable_sync_to_postgres && !$rootScope.parametros.nao_cliente_agrogestao) {
        $rootScope.permissions.propriedades.canManage = false;
      }
    };

    //////////////////////////////////////////
    // Controller logic
    const error = function() {
      Flash.create(FALHA_AO_CONSULTAR_REGISTRO.type, FALHA_AO_CONSULTAR_REGISTRO.msg);
      $location.path('/cadastro_propriedades');
    };

    // eslint-disable-next-line max-lines-per-function
    const initialize = function() {
      LoadingService.showLoading();
      $rootScope.initialize.then(function() {
        permissions();
        if (!$rootScope.permissions.propriedades.canRead) {
          $location.path('/');
          Flash.create(ACESSO_NAO_PERMITIDO.type, ACESSO_NAO_PERMITIDO.msg);
          return;
        }

        if ($routeParams.id) {
          PropriedadesService.get($routeParams.id).then(function(data) {
            vm.propriedade = data.data || {};
            LoadingService.hideLoading();
            if (!vm.propriedade.id) {
              error();
            }
          }, error);
        } else {
          PropriedadesService.all().then(function(data) {
            vm.propriedades = data.data;
            LoadingService.hideLoading();
          })
            .catch(error);
        }
      }, $rootScope.errorRootInitialize);
    };

    vm.searchItems = function() {
      LoadingService.showLoading();
      vm.propriedades = [];
      PropriedadesService.all(vm.search).then(function(data) {
        vm.propriedades = data.data;
        LoadingService.hideLoading();
      })
        .catch(error);
    };

    vm.inactivate = function(propriedade) {
      MessagesService
        .confirm(
          'Deseja realmente inativar esta propriedade?'
        )
        .then(async() => {
          LoadingService.showLoading();
          try {
            await PropriedadesService.inactivate(propriedade);
            vm.searchItems();
          } catch {
            MessagesService.alert('Não foi possível inativar a propriedade.');
            LoadingService.hideLoading();
          }
        });
    };

    vm.activate = function(propriedade) {
      MessagesService
        .confirm(
          'Deseja realmente reativar está propriedade?'
        )
        .then(async() => {
          LoadingService.showLoading();
          try {
            await PropriedadesService.activate(propriedade);
            vm.searchItems();
          } catch {
            MessagesService.alert('Não foi possível reativar a propriedade.');
            LoadingService.hideLoading();
          }
        });
    };

    initialize();
  }
}());
